function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "time--lapse_1_",
  d: "M9.252,20.312l-0.36-0.623l6.749-3.896V5h0.72v11.208L9.252,20.312z M16,30.64 C7.927,30.64,1.36,24.072,1.36,16C1.36,7.927,7.927,1.36,16,1.36c8.072,0,14.64,6.567,14.64,14.64c0,4.402-1.915,8.466-5.279,11.259 V22H24.64v6.36H31v-0.72h-4.976c3.403-2.924,5.336-7.11,5.336-11.64c0-8.47-6.89-15.36-15.36-15.36S0.64,7.53,0.64,16 S7.53,31.36,16,31.36V30.64z"
});
const SvgTimeLapse = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 32 32",
  style: {
    enableBackground: "new 0 0 32 32"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle",
  style: {
    fill: "none"
  },
  width: 32,
  height: 32
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimeLapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/time--lapse.f093e442.svg";
export { ForwardRef as ReactComponent };